<script>
import { HorizontalBar, Charts } from "vue-chartjs";
let colors = ["#006E90", "#FFBC42", "#FF5E5B", "#00CECB", "#B9E6FF"];
export default {
  extends: HorizontalBar,

  data() {
    return {
      //
      chart_options: {
        legend: {
          position: "bottom",
        },
        layout: {
          padding: {
            left: 250,
          },
        },
        title: {
          display: true,
          text: this.title_text,
        },
        scales: {
          yAxes: [
            {
              ticks: {
                mirror: true,
                padding: 250,
                callback: function (value) {
                  if (value.length > 40) {
                    return value.substr(0, 40) + " ...";
                  } else {
                    return value;
                  }
                },
              },
            },
          ],
          xAxes: [
            {
              ticks: {
                beginAtZero: true,
                stepSize: parseFloat(this.step_size),
                max: parseInt(this.range.max),
                min: 0,
              },
            },
          ],
        },
        responsive: true,
        maintainAspectRatio: false,
      },
      datas: this.datas_bar,
    };
  },
  mounted() {
    if (this.static_chart_data.labels.length > 0) {
      this.drawBarsGraph(this.static_chart_data);
    }
  },
  methods: {
    drawBarsGraph(datas_bar) {
      let componentGraph = this;

      let labels = datas_bar.labels;
      datas_bar.datasets.forEach((el, i) => {
        el.backgroundColor = colors[i];
        el.borderColor = colors[i];
      });
      let final = { labels, datasets: datas_bar.datasets };
      console.log(final, "FINAL");
      componentGraph.renderChart(final, componentGraph.chart_options);
      /* setTimeout(function () {
        componentGraph.renderChart(final, componentGraph.chart_options);
      }, 1000); */
    },
  },
  props: {
    static_chart_data: {
      type: Object,
      required: false,
      default() {
        return {
          labels: [],
          datasets: [],
        };
      },
    },
    print: {
      type: Boolean,
      default: true,
    },
    range: {
      type: Object,
      required: true,
    },
    step_size: {
      type: Number,
      required: false,
      default: 0.5,
    },
    title_text: {
      type: String,
      required: false,
      default: "Performance",
    },
  },
};
</script>
